import { IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import api from '../api/api';
import { generateRandomToken } from '../utils/stinggenerator';
import { whitecamera } from '../utils/svgs/svgcode';

const EditUser = ({ CloseEditUser,onFileChange, userrow,fetchUsersData,img }) => {
    const [usersData, setUserData] = useState({});
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userId, setUserId] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [status, setStatus] = useState('');
    const [roles, setRoles] = useState('');
    const [errors, setErrors] = useState({});
    const [isLoading, setLoading] = useState(false);
    const [privileges, setPrivileges] = useState([]);
    const [rolesData,setRolesData]=useState([]);
    const practiseid = window.getPracticeId();
    const [selectedPrivileges, setSelectedPrivileges] = useState([]);
    const dropdowntypes = ["Hourly", "Contractors", "Salaried"];
        const [emptype,setemptype]=useState('')
    let myemp_type=userrow?.config?.emp_type||''
        const handleDropdownChange = (e) => {
    const value = e.target.value;
  
    setemptype(value);
  };
  useEffect(() => {
    if (myemp_type) {
      setemptype(userrow?.config?.emp_type||'');
    }    }, [userrow]);
    // Fetch privileges data
    const fetchPriviData = async () => {
        setLoading(true); // Start loading
        try {
            const response = await api.get(`/v1/${practiseid}/privileges/get`);
            if (response.status === 200) {
                setPrivileges(response.data); // Update state with privileges data
            } else {
                setPrivileges([]); // Empty privileges if no data is found
            }
        } catch (error) {
            console.error(error); // Log any errors
        } finally {
            setLoading(false); // Stop loading
        }
    };

    useEffect(() => {
        fetchPriviData(); // Call fetchData when component mounts
    }, []);

    const fetchRolesData = async () => {
        setLoading(true); // Start loading
        try {
            const response = await api.get(`/v1/${practiseid}/roles/get`);
            if (response.status === 200) {
                setRolesData(response.data); // Update state with privileges data
            } else {
                setRolesData([]); // Empty privileges if no data is found
            }
        } catch (error) {
            console.error(error); // Log any errors
        } finally {
            setLoading(false); // Stop loading
        }
    };

    useEffect(() => {
        fetchRolesData(); // Call fetchData when component mounts
    }, []);


    // Fetch user data
    const fetchUserData = async () => {
        setLoading(true); // Start loading
        try {
            const response = await api.get(`/v1/${practiseid}/user/${userrow.id}`);
            if (response.status === 200) {
                setUserData(response.data[0]); // Assuming response data is an array with a single user object
            } else {
                setUserData({}); // Clear user data if no data is found
            }
        } catch (error) {
            console.error(error); // Log any errors
        } finally {
            setLoading(false); // Stop loading
        }
    };

    useEffect(() => {
        fetchUserData(); // Call fetchUserData when component mounts or userrowId changes
    }, [userrow]);

    // Update form fields when usersData changes
   useEffect(() => {
        if (Object.keys(usersData).length > 0) {
            setFirstName(usersData.firstname || '');
            setLastName(usersData.lastname || '');
            setUserId(usersData.username || ''); // Using username as userId
            setEmail(usersData.email || '');
            setPhone(usersData.phone || '');
            setStatus(usersData.status === 'A' ? 'A' : 'I'); // Converting 'A' to 'Active'
            setRoles(usersData.rolename || ''); // Assuming rolename is the role value

            // Set selected privileges from userrow.permissions
            const userPermissions = JSON.parse(userrow.permissions);
            setSelectedPrivileges(userPermissions);
        }
    }, [usersData, userrow]);

    const handlePrivilegeChange = (e) => {
        const { value, checked } = e.target;

        // Add or remove the privilege id from the selected list
        if (checked) {
            setSelectedPrivileges((prevSelected) => [...prevSelected, value]);
        } else {
            setSelectedPrivileges((prevSelected) =>
                prevSelected.filter((id) => id !== value)
            );
        }
    };
    useEffect(()=>{

    },[])
 
    const handleRoleChange = (e) => {
        const selectedRoleName = e.target.value;
        setRoles(selectedRoleName);
        // Find the selected role object based on the role name
        const selectedRole = rolesData.find((role) => role.role === selectedRoleName);
        console.log(selectedRole)
        if (selectedRole) {
         
          // Filter the privileges based on the selected role ID
          const updatedPrivileges = privileges.filter((privilege) => {
            // Parse the stringified 'role' array into a real array and check if the selectedRole.id is in it
            const rolesArray = JSON.parse(privilege.role); // Convert stringified role array to an actual array
            return rolesArray.includes(selectedRole.id.toString()); // Compare the role ID
          });
          // Set the selected privileges that match the selected role
          const selectedPrivs = updatedPrivileges.map((privilege) => privilege.id.toString());
          setSelectedPrivileges(selectedPrivs);  // Update selected privileges
        }
      };

    const validateEmail = (email) => {
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return re.test(email);
    };

    const validatePhone = (phone) => {
        const re = /^[0-9]{10}$/; // Simple validation for a 10-digit phone number
        return re.test(phone);
    };

   
    const handleEditUser= async ({UserData}) => {
        const errors = {};
  if (!validateEmail(email)) {
    errors.email = "Please enter a valid email.";
  }
  if (!validatePhone(phone)) {
    errors.phone = "Please enter a valid phone number.";
  }
 const selectedRole = rolesData.find((role) => role.role === roles);
  // If there are errors, don't proceed
  if (Object.keys(errors).length > 0) {
    setErrors(errors);
    return;
  }
//   "IT - Development"
//IT- Admin"
//"IT - Development"
//"Practice - Admin"
//"IT - QA"
         const token = generateRandomToken();
        const payload ={
            "rowid": UserData.id,
            "practiceid":practiseid,
            "firstname":firstName,
            "lastname": lastName,
            "email":email,
            "username":userId,
            "phone":phone,
            "permissions":selectedPrivileges,
            "grole":selectedRole?.id||UserData.grole,
            "status":status,
            "token":token
        }
        try {
          const response = await api.put(`/v1/${practiseid}/user`, payload);
          if(emptype!==myemp_type){
               await api.put(`/v1/${practiseid}/user/config`, {
                            "rowid":usersData.id,
                             "emp_type":emptype,
          
                                 })
          }
          if (response.status === 200) {
            fetchUsersData()
            CloseEditUser()
            window.location.reload();
          } else {
            console.error("Failed to assign room");
          }
        } catch (error) {
          console.error("Error assigning room:", error);
        }
      };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-y-auto">
            {/* Popup Box */}
            <div className="relative flex flex-col w-[60%] bg-white pb-2 p-3 rounded-lg shadow-lg text-left max-h-[98vh] overflow-y-auto">
                <div className="flex justify-between items-center border-b pb-2">
                    <h3 className="font-semibold text-lg">Edit User </h3>
                    <IconButton onClick={CloseEditUser} className="text-gray-600 hover:text-gray-700">
                        <CloseIcon fontSize="medium" />
                    </IconButton>
                </div>
                <div className='flex w-full justify-center'>
                        <div className="relative w-[70px] h-[70px] rounded-[14px] border-4 border-white bg-gray-200 shadow">
                                <img
                                src={`data:image/jpeg;base64,${img}`}
                                  alt="Profile"
                                  className="object-cover w-full h-full rounded-[14px]"
                                       onError={(e) => e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
                                />
                                <input
                                  type="file"
                                  accept="image/*"
                                onChange={(e) =>{

                                    onFileChange({file:e.target.files[0],id: userrow.id})
                                }}
                                  className="absolute inset-0 opacity-0 cursor-pointer"
                                />
                                <div className="absolute bottom-0 right-0 translate-x-1/2 translate-y-1/2 p-1 rounded-full bg-[#E17954] shadow">
                                  {whitecamera}
                                </div>
                              </div>

                </div>
                <div className="grid grid-cols-2 gap-4 mt-3">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">First Name</label>
                        <input
                            type="text"
                            className="p-2 border border-gray-300 rounded-md w-full"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Last Name</label>
                        <input
                            type="text"
                            className="p-2 border border-gray-300 rounded-md w-full"
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">User ID</label>
                        <input
                            type="text"
                            className="p-2 border border-gray-300 rounded-md w-full"
                            value={userId}
                            onChange={(e) => setUserId(e.target.value)}
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Email</label>
                        <input
                            type="text"
                            className={`p-2 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-md w-full`}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {errors.email && <p className="text-red-500 text-xs">{errors.email}</p>}
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Phone</label>
                        <input
                            type="text"
                            className={`p-2 border ${errors.phone ? 'border-red-500' : 'border-gray-300'} rounded-md w-full`}
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        {errors.phone && <p className="text-red-500 text-xs">{errors.phone}</p>}
                    </div>

                    {/* Status Dropdown */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Status</label>
                        <select
                            className="p-2 border border-gray-300 rounded-md w-full"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="A">Active</option>
                            <option value="I">Inactive</option>
                        </select>
                    </div>

                    {/* Roles Dropdown */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Roles</label>
                        <select
                className="p-2 border border-gray-300 rounded-md w-full cursor-pointer"
                value={roles}
                onChange={handleRoleChange}
            >
                <option value="">Select </option>
                {rolesData.map((role) => (
                        <option key={role.id} value={role.role}>
                            {role.role}
                        </option>
                    ))}
                  </select>
                    </div>
                          {/* Employee Type Dropdown */}
      <div className="mb-6">
        <label
          htmlFor="emptype"
          className="block text-sm text-start font-medium text-gray-700 mb-2"
        >
          Select Employee Type
        </label>
        <select
          id="emptype"
          value={emptype}
          onChange={handleDropdownChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#1e90ff]"
        >
          <option value="">-- Select Type --</option>
          {dropdowntypes.map((type, index) => (
            <option key={index} value={type}>
              {type}
            </option>
          ))}
        </select>
      </div>
                </div>
                {/* Add the privileges part */}
                {/* ... (rest of the code for privileges) */}
                <div className="grid grid-cols-4 gap-4 mt-3 ml-2">
                    {/* Iterate through privileges for each page */}
                    {['Home Screen', 'Tasks', 'Side Bar', 'RPM', 'QA', 'Payment'].map((page) => (
                        privileges.filter(privilege => privilege.page === page).length > 0 && (
                            <div key={page}>
                                <h2 className="text-lg font-semibold">{page} Privileges</h2>
                                <div className="space-y-2 col-span-1">
                                    {privileges.filter(privilege => privilege.page === page).map((privilege) => (
                                        <div key={privilege.id} className="flex items-center">
                                            <input
                                                type="checkbox"
                                                id={`privilege-${privilege.id}`}
                                                value={privilege.id}
                                                onChange={handlePrivilegeChange}
                                                checked={selectedPrivileges.includes(privilege.id.toString())}
                                                className="mr-2 cursor-pointer"
                                            />
                                            <label htmlFor={`privilege-${privilege.id}`} className="text-sm">
                                                {privilege.privilege}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )
                    ))}
                </div>

                <div className="flex w- justify-end gap-4 mt-4">
                    {/* Cancel Button */}
                    <button
                        onClick={CloseEditUser}
                        className="py-2 px-4 bg-gray-100 rounded-lg text-gray-700 hover:bg-gray-200"
                    >
                        Cancel
                    </button>

                    {/* Yes Button - Edit User */}
                    <button onClick={()=>handleEditUser({UserData:userrow})}
                        className="py-2 px-4 bg-gray-400 text-white rounded-lg hover:bg-orange-400"
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    );
};

export default EditUser;
